export enum QuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  InputNumeric = 'INPUT_NUMERIC',
  InputText = 'INPUT_TEXT',
}
